import { render, staticRenderFns } from "./inactiveCompanyComponent.vue?vue&type=template&id=93819406&"
import script from "./inactiveCompanyComponent.vue?vue&type=script&lang=js&"
export * from "./inactiveCompanyComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports